import React, { useEffect, useState, useCallback, useRef } from "react";
import styles from "./styles.module.css";
import lynkit from "../../../../images/lynkit.png";
import { Link, scroller } from "react-scroll";
import { useHistory } from "react-router-dom";

const MenuIcon = () => (
  <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

const CloseIcon = () => (
  <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

const ChevronDownIcon = ({ className }) => (
  <svg aria-hidden="true" focusable="false" className={className} width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PRODUCT_CATEGORIES = [
  {
    heading: "In Transit",
    items: [
      { name: "Real Time Visibility", desc: "IoT And Camera-Based Real-Time Tracking Of Vehicles, Assets, And Cargo.", path: "/fleet-management-system" },
      { name: "Lynktrac", desc: "One Platform To Track And Secure Shipments Across Land And Sea.", path: "/fleet-management-system" },
      { name: "Real Time Visibility", desc: "IoT And Camera-Based Real-Time Tracking Of Vehicles, Assets, And Cargo.", path: "/fleet-management-system" },
      { name: "Lynktrac", desc: "One Platform To Track And Secure Shipments Across Land And Sea.", path: "/fleet-management-system" },
    ],
  },
  {
    heading: "Freight And Transport Management",
    items: [
      { name: "Lynkit.io", desc: "One Transportation ERP Connecting Shippers, Transporters, And Suppliers For Smarter Cost Control.", path: "/transport-management-system" },
      { name: "Lynkit XBL", desc: "A Freight Intelligence Platform For Smarter, Data-Backed Buying Decisions.", path: "/xeneta" },
    ],
  },
  {
    heading: "Inventory And Warehouse Management",
    items: [
      { name: "Lynkgrid WMS", desc: "An Intelligent WMS With AR-Based Tracking To Optimize Inventory And Manpower.", path: "/warehouse-management-system" },
      { name: "LynkID Asset Management", desc: "A Centralized System To Track And Manage Assets Across Their Lifecycle.", path: "/warehouse-management-system" },
    ],
  },
  {
    heading: "Yard Management",
    items: [
      { name: "LynkID Gate Automation", desc: "A Smart Gate System To Reduce Delays, Integrate Weighbridge Data, And Catch Billing Mismatches.", path: "/asset-tracking-system" },
      { name: "LynkID Dock Management", desc: "An Automated Dock Platform To Streamline Scheduling, Movement, And Load Checks—Cutting Wait Times And Congestion.", path: "/asset-tracking-system" },
    ],
  },
];

const KNOWLEDGE_ITEMS = [
  { label: "DID YOU KNOW?", action: "knowledge" },
  { label: "BLOG", href: "https://blog.lynkit.in/" },
  { label: "E-BOOK", action: "e-book" },
  // { label: "TUTORIALS", action: "videos" },
  { label: "USECASES", action: "usecase" },
];

/* ── Mobile accordion sections ── */
const MOBILE_ACCORDION = [
  { label: "HOME", action: "Home" },
  {
    label: "PRODUCTS",
    children: PRODUCT_CATEGORIES.flatMap((cat) =>
      cat.items.map((item) => ({ label: item.name, path: item.path }))
    ).concat([{ label: "Lynkgrid YMS", href: "https://www.lynkgrid.com/login" }]),
  },
  { label: "AI LAYER", action: "Ailayer" },
  {
    label: "COMPANY",
    children: [
      { label: "About Us", action: "About_us" },
      { label: "Advisory Board", action: "Advisory_Board" },
    ],
  },
  {
    label: "KNOWLEDGE BANK",
    children: [
      { label: "Did You Know?", action: "knowledge" },
      { label: "Blog", href: "https://blog.lynkit.in/" },
      { label: "E-Book", action: "e-book" },
      // { label: "Tutorials", action: "videos" },
      { label: "UseCases", action: "usecase" },
    ],
  },
  { label: "API", action: "Api" },
  { label: "PATENTS", action: "patent" },
];

const SCROLL_ROUTES = {
  products: { pushPath: "/products", section: "products-section", offset: -48 },
  enterprise: { pushPath: "/enterprise", section: "Enterprise_div", offset: -52 },
};

const DIRECT_ROUTES = {
  Home: "/", ContactUs: "/ContactUs", About_us: "/About_us",
  Advisory_Board: "/Advisory_Board", Careers: "/Careers",
  knowledge: "/knowledge-bank", "e-book": "/e-book",
  videos: "/videos", blog: "/blog", patent: "/patent", Api: "/Api",
  usecase: "/usecases", Ailayer: "/ai-layer",
};

const PATH_STATE_MAP = [
  { keywords: ["/", "/products", "/enterprise"], state: "Home", exact: true },
  { keywords: ["ContactUs"], state: "ContactUs" },
  { keywords: ["Advisory_Board"], state: "Advisory_Board" },
  { keywords: ["About_us"], state: "About_us" },
  { keywords: ["Careers"], state: "Careers" },
  { keywords: ["knowledge"], state: "knowledge" },
  { keywords: ["usecase", "usecases"], state: "usecase" },
  { keywords: ["Api"], state: "Api" },
  { keywords: ["Ailayer", "aiLayer", "ailayer", "ai-layer"], state: "Ailayer" },
  { keywords: ["Patent"], state: "Patent" },
];

const HIDDEN_PATHS = ["/fleet-management-system", "/transport-management-system", "/warehouse-management-system", "/asset-tracking-system"];

/* ── Reusable scroll link ── */
const NavScrollLink = ({ to, offset, isHomeGroup, onClick, children, className }) => (
  <Link to={to} spy smooth offset={offset} duration={500} activeClass={isHomeGroup ? styles.active_class : ""} onClick={onClick} className={className}>
    {children}
  </Link>
);

/* ── Main Component ── */
const Navbar = () => {
  const [showLinks, setShowLinks] = useState(false);
  const [activeState, setActiveState] = useState("Home");
  const [showProductsMega, setShowProductsMega] = useState(false);
  const [expandedSection, setExpandedSection] = useState(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const hoverTimeoutRef = useRef(null);
  const history = useHistory();
  const path1 = history.location.pathname;

  const resolveActiveState = useCallback((pathname) => {
    for (const { keywords, state, exact } of PATH_STATE_MAP) {
      if (exact ? keywords.includes(pathname) : keywords.some((k) => pathname.includes(k))) {
        setActiveState(state);
        return;
      }
    }
  }, []);

  useEffect(() => { resolveActiveState(path1); }, [path1, resolveActiveState]);

  // Track scroll position — navbar transparent at top to show hero video
  useEffect(() => {
    const handleScroll = () => setIsAtTop(window.scrollY <= 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = showLinks ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showLinks]);

  const isOnHomePage = () => ["/", "/products", "/enterprise"].includes(path1);

  const routeAndScroll = (path) => {
    setActiveState(path);
    setShowLinks(false);
    setShowProductsMega(false);
    setExpandedSection(null);

    if (SCROLL_ROUTES[path]) {
      const { pushPath, section, offset } = SCROLL_ROUTES[path];
      history.push(pushPath);
      const delay = isOnHomePage() ? 0 : 600;
      setTimeout(() => scroller.scrollTo(section, { smooth: true, offset, duration: 500 }), delay);
      return;
    }
    if (DIRECT_ROUTES[path]) {
      history.push(DIRECT_ROUTES[path]);
      if (path === "Home") window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const navigateToProduct = (e, productPath) => {
    e.preventDefault();
    setShowProductsMega(false);
    setShowLinks(false);
    setExpandedSection(null);
    history.push(productPath);
  };

  const toggleMenu = () => {
    setShowLinks((prev) => !prev);
    setExpandedSection(null);
  };

  const toggleAccordion = (label) => {
    setExpandedSection((prev) => (prev === label ? null : label));
  };

  const isHomeGroup = ["enterprise", "products", "Home"].includes(activeState);
  const isNavbarHidden = HIDDEN_PATHS.some((p) => path1 === p) || path1?.includes("xeneta");

  return (
    <div className={`${styles.Navbar} ${isAtTop && isOnHomePage() ? styles.navbarTransparent : ""}`} style={{ display: isNavbarHidden ? "none" : "flex" }}>
      <button className={styles.reorder} onClick={toggleMenu} type="button" aria-label={showLinks ? "Close menu" : "Open menu"}>
        {showLinks ? <CloseIcon /> : <MenuIcon />}
      </button>

      <div className={styles.leftside}>
        <a href="/"><img className={styles.logo} src={lynkit} alt="logo" /></a>

        {/* ── Desktop nav links ── */}
        <div className={styles.links}>
          <NavScrollLink to="headings" offset={-110} isHomeGroup={isHomeGroup} onClick={() => routeAndScroll("Home")} className={styles.nav_link}>
            HOME
          </NavScrollLink>

          {/* PRODUCTS mega menu */}
          <div
            className={styles.navbar_products_wrapper}
            onMouseEnter={() => { clearTimeout(hoverTimeoutRef.current); setShowProductsMega(true); }}
            onMouseLeave={() => { hoverTimeoutRef.current = setTimeout(() => setShowProductsMega(false), 150); }}
          >
            <span className={`${styles.products_nav_trigger} ${activeState === "products" ? styles.active_class : ""}`} onClick={() => routeAndScroll("products")}>
              <span className={styles.products_nav_text}>PRODUCTS</span>
              <span className={styles.products_chevron}>&#9662;</span>
            </span>

            {showProductsMega && (
              <div className={styles.products_mega_menu}>
                <div className={styles.mega_menu_inner}>
                  {/* Hero column */}
                  <div className={styles.mega_hero_col}>
                    <p className={styles.mega_hero_text} style={{ color: "#ff7700" }}>
                      Powering Logistics With <span className={styles.mega_hero_highlight} style={{ color: "#fff" }}>#AI-Driven</span> Supply Chain Automation
                    </p>
                    <p className={styles.mega_hero_subtext} style={{ color: "#FFFFFFB2" }}>Trusted By Leading Brands To Run Logistics Operations</p>
                    <button className={styles.mega_hero_btn} onClick={() => { setShowProductsMega(false); routeAndScroll("ContactUs"); }}>
                      Book A Demo
                    </button>
                  </div>

                  {/* Products grid — single shared grid so rows align */}
                  <div className={styles.mega_products_grid}>
                    {/* Row 1: Headings */}
                    {PRODUCT_CATEGORIES.map((cat) => (
                      <h4 className={styles.mega_col_heading} key={cat.heading}>{cat.heading}</h4>
                    ))}

                    {/* Row 2: First product from each category */}
                    {PRODUCT_CATEGORIES.map((cat) => (
                      <a key={cat.items[0].name} className={styles.mega_product_item} href={cat.items[0].path} onClick={(e) => navigateToProduct(e, cat.items[0].path)}>
                        <span className={styles.mega_product_name}>{cat.items[0].name}</span>
                        <span className={styles.mega_product_desc} style={{ color: "#fff" }}>{cat.items[0].desc}</span>
                      </a>
                    ))}

                    {/* Row 3: Second product from each category */}
                    {PRODUCT_CATEGORIES.map((cat) => (
                      <a key={cat.items[1].name} className={styles.mega_product_item} href={cat.items[1].path} onClick={(e) => navigateToProduct(e, cat.items[1].path)}>
                        <span className={styles.mega_product_name}>{cat.items[1].name}</span>
                        <span className={styles.mega_product_desc} style={{ color: "#fff" }}>{cat.items[1].desc}</span>
                      </a>
                    ))}
                  </div>

                  <div className={styles.mega_menu_bottom_row}>
                    <span className={styles.mega_bottom_heading}>Container Terminal Management</span>
                    <span className={styles.mega_bottom_arrow}>&#9654;</span>
                    <a className={styles.mega_bottom_link} href="https://www.lynkgrid.com/login" target="_blank">
                      Lynkgrid YMS
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          <a
            className={`${styles.nav_link} ${activeState === "Ailayer" ? styles.active_class : ""}`}
            onClick={(event) => {
              event.preventDefault();
              routeAndScroll("Ailayer");
            }}
            href="/ai-layer"
          >
            AI LAYER
          </a>

          {/* COMPANY dropdown */}
          <div className={`${styles.dropdown} ${styles.navbar_company}`}>
            <a className={styles.links_navbar1}>COMPANY</a>
            <div className={styles.dropdown_menu}>
              <a className={activeState === "About_us" ? styles.active_class_drop_1 : styles.dropdown1} onClick={() => routeAndScroll("About_us")}>ABOUT US</a>
              <a className={activeState === "Advisory_Board" ? styles.active_class_drop_2 : styles.dropdown2} onClick={() => routeAndScroll("Advisory_Board")}>ADVISORY BOARD</a>
            </div>
          </div>

          {/* KNOWLEDGE BANK dropdown */}
          <div className={`${styles.dropdown} ${styles.navbar_knowledge}`}>
            <a className={styles.links_navbar1}>KNOWLEDGE BANK</a>
            <div className={styles.dropdown_menu}>
              {KNOWLEDGE_ITEMS.map((item, i) => (
                <div className={styles.dropItem_container} key={item.label} style={i === 0 ? { marginTop: "10px" } : undefined}>
                  {item.href ? (
                    <a className={styles.dropItem} target="_blank" rel="noreferrer" href={item.href}>{item.label}</a>
                  ) : (
                    <a className={styles.dropItem} onClick={() => routeAndScroll(item.action)}>{item.label}</a>
                  )}
                </div>
              ))}
            </div>
          </div>

          <a className={`${styles.nav_link} ${activeState === "Api" ? styles.active_class : ""}`} onClick={() => routeAndScroll("Api")} href="/Api">API</a>

          <NavScrollLink to="Patent" offset={-52} isHomeGroup={isHomeGroup} onClick={() => routeAndScroll("patent")} className={styles.nav_link}>
            PATENTS
          </NavScrollLink>
        </div>
      </div>

      <div className={styles.rightside}>
        <button onClick={() => routeAndScroll("ContactUs")} className={activeState === "ContactUs" ? styles.new_btn_color : styles.contactbtn}>
          CONTACT US
        </button>
      </div>


      {showLinks && (
        <div className={styles.mobile_overlay} onClick={toggleMenu}>
          <div className={styles.mobile_drawer} onClick={(e) => e.stopPropagation()}>
            {/* Drawer header */}
            <div className={styles.mobile_drawer_header}>
              <a href="/"><img src={lynkit} alt="logo" className={styles.mobile_logo} /></a>
              <button className={styles.mobile_close_btn} onClick={toggleMenu} type="button" aria-label="Close menu">
                <CloseIcon />
              </button>
            </div>

            {/* Accordion items */}
            <nav className={styles.mobile_nav}>
              {MOBILE_ACCORDION.map((section) =>
                section.children ? (
                  <div className={styles.mobile_accordion_item} key={section.label}>
                    <button
                      className={`${styles.mobile_accordion_trigger} ${expandedSection === section.label ? styles.expanded : ""}`}
                      onClick={() => toggleAccordion(section.label)}
                      type="button"
                    >
                      <span>{section.label}</span>
                      <ChevronDownIcon className={`${styles.mobile_accordion_icon} ${expandedSection === section.label ? styles.rotated : ""}`} />
                    </button>

                    <div className={`${styles.mobile_accordion_panel} ${expandedSection === section.label ? styles.open : ""}`}>
                      {section.children.map((child) =>
                        child.href ? (
                          <a key={child.label} className={styles.mobile_sub_link} href={child.href} target="_blank" rel="noreferrer">
                            {child.label}
                          </a>
                        ) : child.path ? (
                          <a key={child.label} className={styles.mobile_sub_link} href={child.path} onClick={(e) => navigateToProduct(e, child.path)}>
                            {child.label}
                          </a>
                        ) : (
                          <a key={child.label} className={styles.mobile_sub_link} onClick={() => routeAndScroll(child.action)}>
                            {child.label}
                          </a>
                        )
                      )}
                    </div>
                  </div>
                ) : (
                  <a
                    key={section.label}
                    className={styles.mobile_nav_link}
                    onClick={() => routeAndScroll(section.action)}
                  >
                    {section.label}
                  </a>
                )
              )}
            </nav>

            {/* CTA button at bottom */}
            <div className={styles.mobile_drawer_footer}>
              <button className={styles.mobile_cta_btn} onClick={() => routeAndScroll("ContactUs")}>
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
